import { Link } from 'react-router-dom';
import { latestComics } from '@/mocks/comics';

export default function CTASection() {
  return (
    <section className="w-full py-14 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <span className="inline-block px-3 py-1 rounded-full bg-accent-100 text-accent-800 text-xs font-semibold tracking-wide mb-3">
            最新上架
          </span>
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950">
            新鲜出炉，追漫不等待
          </h2>
          <p className="text-sm text-foreground-600 mt-2 max-w-lg mx-auto">
            最新热门韩漫持续更新中，点击立即开启阅读之旅
          </p>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-6 gap-4 mb-10">
          {latestComics.map((comic, index) => (
            <Link
              key={comic.id}
              to={`/comic/${comic.slug}`}
              className={`group rounded-xl overflow-hidden transition-all duration-300 hover:-translate-y-1 cursor-pointer ${
                index % 2 === 0 ? 'bg-background-100' : 'bg-background-200/70'
              }`}
            >
              <div className="aspect-[3/4] overflow-hidden">
                <img
                  src={comic.cover}
                  alt={comic.title}
                  className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
                  loading="lazy"
                />
              </div>
              <div className="p-3">
                <h4 className="font-heading text-sm font-bold text-foreground-950 line-clamp-1">{comic.title}</h4>
                <div className="flex items-center gap-2 mt-1 text-xs text-foreground-500">
                  <span>{comic.chapters}话</span>
                  <span className="text-accent-500">
                    <i className="ri-star-fill text-[10px]"></i> {comic.rating}
                  </span>
                </div>
              </div>
            </Link>
          ))}
        </div>

        <div className="text-center">
          <Link
            to="/category/romance"
            className="inline-flex items-center gap-2 px-8 py-3 rounded-full bg-primary-500 text-background-50 text-sm font-semibold hover:bg-primary-600 transition-all duration-200 whitespace-nowrap cursor-pointer"
          >
            <span>浏览全部漫画</span>
            <i className="ri-arrow-right-line"></i>
          </Link>
        </div>
      </div>
    </section>
  );
}